import { FC, useState } from "react";
import { ReviewComment } from "../../Product.type";
import styles from "./review-comments.module.css";
import Star from "@sumerkit/icons/star/ssr";
import CaretDown from "@sumerkit/icons/caret-down/ssr";
import { TFunction } from "i18next";
import dayjs from "dayjs";

export type ReviewCommentsTypes = {
  comments: Array<ReviewComment>;
  globalAverage: number;
  t: TFunction;
  isMobile: boolean;
};

const ReviewComments: FC<ReviewCommentsTypes> = ({
  comments,
  globalAverage,
  t,
  isMobile
}) => {
  const starNumber = new Array<string>(5).fill("");
  const [showMore, setShowMore] = useState<boolean>(false);

  const formattedDate = (scoreDate: string): string => {
    return dayjs(scoreDate).format("LL");
  };

  const showComment = (index: number): boolean => {
    const itemsNumber = isMobile ? 2 : 5;
    if (showMore && index > itemsNumber || index <= itemsNumber) {
      return true;
    }
    return false;
  };

  const showMoreReviews = (): boolean => {
    if (isMobile && comments.length > 3) {
      return true;
    }
    if (!isMobile && comments.length > 6) {
      return true;
    }
    return false;
  };

  return (
    <div className={styles.reviewCommentsWrapper}>
      <div className={styles.header}>
        <div className={styles.title}>
          {t("orderReview.reviewProductDetail.ratings")} ({comments.length})
        </div>
        <div className={styles.calification}>
          <Star weight={"fill"} width='24px' height='24px' />
          <div className={styles.text}>{globalAverage}</div>
        </div>
      </div>
      <div className={styles.commentsContainer}>
        {comments.
        sort((a, b) => b.stars - a.stars).
        map(
          (comment, i) =>
          showComment(i) &&
          <div className={styles.commentsItem} key={`comment-${i}`}>
                  <div className={styles.comment}>
                    <div className={styles.title}>
                      <div className={styles.text}>
                        {comment.authorName !== " " ?
                  comment.authorName :
                  "Anonimo"}
                      </div>
                      <div className={styles.calification}>
                        <div className={styles.stars}>
                          {starNumber.map((star, j) =>
                    <Star
                      weight={`${j < comment.stars ? "fill" : "light"}`}
                      width='12px'
                      height='12px'
                      key={`star-${j}`} />

                    )}
                        </div>
                        <div className={styles.separator}>•</div>
                        <div className={styles.date}>
                          {formattedDate(comment.scoreDate)}
                        </div>
                      </div>
                    </div>
                    <div className={styles.description}>
                      {comment.customerComments}
                    </div>
                  </div>
                </div>

        )}
      </div>
      {showMoreReviews() &&
      <div className={styles.footer}>
          <div
          className={styles.controls}
          onClick={() => setShowMore((s) => !s)}>

            <div className={styles.text}>
              {!showMore ?
            t("orderReview.reviewProductDetail.moreReviews") :
            t("orderReview.reviewProductDetail.lessReviews")}
            </div>
            <div className={styles.icon}>
              <CaretDown className={`${showMore && styles.caret}`} />
            </div>
          </div>
        </div>}

    </div>);

};

export default ReviewComments;